import { Injectable } from '@angular/core';
import { Auth } from 'aws-amplify';
import { Observable, Subject } from 'rxjs';
import { gsap } from 'gsap';
import { ConstantsService } from './constants.service';
import { SpinnerService } from './spinner.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SharedMixpanelService } from './shared-mixpanel.service';
@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private playMusicSubject = new Subject<any>();
  playMusic = this.playMusicSubject.asObservable();
  url: string;
  textCopied: boolean;
  startPayment;
  private subject = new Subject<any>();
  fromPricingPage: any;
  private giftPaymentSuccess:boolean = false;
  constructor(
    private constants: ConstantsService,
    private spinner: SpinnerService,
    private route: Router,
    private mixpanel: SharedMixpanelService) {
  }
  isAuthenticated: boolean;
  isLoaded: boolean;
  async getAuthentication() {
    await Auth.currentAuthenticatedUser()
      .then(() => {
        const redirectUrl = localStorage.getItem('redirectAfterLogin');
        if(redirectUrl){
          localStorage.removeItem('redirectAfterLogin');
          this.route.navigate([redirectUrl]);
        }
        this.isAuthenticated = true;
        return new Promise(resolve => {
          resolve(this.isAuthenticated);
        });
      }).catch((err) => {
        this.isAuthenticated = false;
        return new Promise(resolve => {
          resolve(this.isAuthenticated);
        });
      })
    setTimeout(() => {
      this.spinner.hide()
    }, 1000);
    return new Promise(resolve => {
      resolve(this.isAuthenticated);
    });

  }
  async getAuthUser() {
    this.spinner.show()
    let login = <boolean>await this.getAuthentication()
    this.logout()
    if (login) {
      let Key
      let picture;
      let Items;
      for (let items in localStorage) {
        let userData = items.includes("userData")
        if (userData) {
          Key = items
        }
      }
      const cognitoUser = JSON.parse(localStorage.getItem(Key))
      const UserAttributes = cognitoUser.UserAttributes
      let userArray = {}
      UserAttributes.forEach(element => {
        let { Name, Value } = element
        userArray[Name] = Value
      });
      if (userArray["picture"] === undefined) {
        picture = this.constants.AVATAR_IMG;
      }
      else {
        let userName = cognitoUser.Username
        if (userName.includes("facebook")) {
          let profPic = userArray["picture"]
          picture = JSON.parse(profPic)['data']['url']
        }
        else if (userName.includes("google")) {
          picture = userArray["picture"]
        }
      }
      return Items = {
        login: true,
        userName: cognitoUser.Username,
        family_name: userArray["family_name"],
        given_name: userArray["given_name"],
        picture: picture,
        email: userArray["email"],
      }
    }
    else {
      let Items
      return Items = {
        login: false,
        isPrime: false
      }
    }
  }
  logout() {
    Auth.currentSession()
      .catch(() => {
        this.mixpanel.actions.reset()
        localStorage.removeItem('user')
        localStorage.removeItem('myWindowCache')
        localStorage.removeItem('bookmarked_Cache')
        localStorage.removeItem('PendingList')
        localStorage.removeItem('ApprovedCache')
        localStorage.removeItem('rejectedCache')
        localStorage.removeItem('watchedVideos')
      })
  }
  sendEvent() {
    this.subject.next();
  }
  getEvent(): Observable<any> {
    return this.subject.asObservable();
  }
  set(data) {
    this.url = data;

  }
  get() {
    return this.url;
  }
  animateUI(type) {
    let loginTl = gsap.timeline();
    let titleTl = gsap.timeline();
    let textTl = gsap.timeline();
    let footerTl = gsap.timeline();
    let imgTL = gsap.timeline();
    let aboutTl = gsap.timeline();
    let buttonTl = gsap.timeline();
    let closeButtonTl = gsap.timeline();
    if (type === "slide") {
      loginTl.from(['#slideanimation'], {
        delay: .1,
        opacity: 0,
        x: 1000,
        duration: 0.8,
        ease: "power3.outIn",
        stagger: {
          amount: 0.4,
        },
      })
    }
    else if (type === "easein") {
      titleTl.from('#title-box-1', {

        opacity: 0,
        y: 40,
        duration: 0.8,
        ease: "power3.outIn",
      });
      textTl.from(['#text-box-1', '#text-box-2', '#text-box-3'], {
        delay: .8,
        opacity: 0,
        y: 10,
        duration: 1,
        ease: "power3.outIn",
        stagger: {
          amount: 0.4,
        },
      })
      footerTl.from(['#credits-box-sm', '#credits-box-lg'], {
        delay: .5,
        opacity: 0,
        y: 10,
        duration: 0.8,
        ease: "power3.outIn",
        stagger: {
          amount: 1,
        },
      })

    }
    else if (type === "easeinout") {
      closeButtonTl.to(['#banner-bg-addition', '#banner-bg'], {
        duration: 1.2,
        y: 1500,
        x: 0,
        ease: "gsap.InOut",
        stagger: {
          amount: 0.3,
        }
      });

      imgTL.to('#img-item', 0.8, {
        opacity: 1,
        delay: 0.4,
        ease: "gsap.power3"
      });


      titleTl.to('#titleItem', 0.8, {
        y: 0,
        opacity: 1,
        delay: 0.4,
        ease: "gsap.power3"
      });

      setTimeout(() => {
        buttonTl.to(['#buttonItem1', '#buttonItem2', '#buttonItem3', '#buttonItem4'], 1.8, {
          opacity: 1,
          delay: 0.4,
          ease: "gsap.power3"
        });
      });

    }
    else if (type === "show-ui") {
      setTimeout(() => {
        buttonTl.to(['#total_container_1', '#total_container'], 0.9, {
          opacity: 1,
          delay: 0,
          ease: "gsap.power3"
        });
      });
    }
    else if (type === "hide-ui") {
      setTimeout(() => {
        buttonTl.to(['#total_container_1', '#total_container'], 1.8, {
          opacity: 0,
          delay: 0,
          ease: "gsap.power3"
        });
      });

    }
    else if (type === "easein-bottom-top") {
      aboutTl.to(['#map-navar', '#nav-bar', '#footer'], 0.8, {
        y: 0,
        opacity: 1,
        delay: 0.2,
        ease: "gsap.power3"
      });
    }
    else if (type === "easeout-top") {
      aboutTl.to(['#map-navar', '#nav-bar'], 2, {
        y: -60,
        opacity: 0,
        delay: 0,
        ease: "gsap.power3"
      });
    }
    else if (type === "easeout-bottom") {
      aboutTl.to(['#footer'], 2, {
        y: 60,
        opacity: 0,
        delay: 0,
        ease: "gsap.power3"
      });
    }
    else if (type === "easeout-right") {
      aboutTl.to(['#container_1'], 2, {
        x: 65,
        opacity: 1,
        delay: 0,
        ease: "gsap.power3"
      });
    } else if (type === "campaign-hide") {
      aboutTl.to(['#viator'], 2, {
        x: 200,
        opacity: 1,
        delay: 0,
        ease: "gsap.power3"
      });
    }
    else if (type === "easein-right") {
      aboutTl.to(['#container_1'], 0.8, {
        x: 0,
        opacity: 1,
        delay: 0.2,
        ease: "gsap.power3"
      });
    }
    else if (type === "campaign-view") {
      aboutTl.to(['#viator'], 0.8, {
        x: 0,
        opacity: 1,
        delay: 0.2,
        ease: "gsap.power3"
      });
    }
    else if (type === "easeinoutGift") {
      let timeline = gsap.timeline();

      timeline
        .to(['#banner-bg-addition', '#banner-bg'], {
          duration: 1.2,
          y: 1500,
          ease: "gsap.InOut",
          stagger: { amount: 0.3 },
        })
        .set(['#banner-bg-addition', '#banner-bg'], { display: "none" }) // Hide background
        .fromTo('.header-section',
          { opacity: 0 },  // Start fully hidden
          { opacity: 1, duration: 0.6, ease: "power3.out" }, "-=1.1");
    }

  }
  onPlayMusic(data) {
    this.playMusicSubject.next(data)
  }
  playmusic() {
    return this.playMusic
  }
  onPayPopOpen(data) {
    this.startPayment = data
  }
  startpayment() {
    return this.startPayment
  }

  getGiftPayment() {
    return this.giftPaymentSuccess;
 }

 setGiftPayment(value:boolean) {
  this.giftPaymentSuccess = value;
 }
}
